import React from "react";

function Header() {
  return (
    <div>
      <h1>Employee Directory</h1>
    </div>
  );
}
export default Header;
